function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { useEffect } from 'react';
import { Time } from '../../../models/date';
import { formatDate, parseDate } from '@bydesign-ui/utils';
import { useRefCallback, useRefGetter, useSingleton } from '@bydesign-ui/hooks';
export function useSimpleTime(options) {
  var part = options.part,
      value = options.value,
      onChange = options.onChange,
      locale = options.locale,
      format = options.format,
      extra = _objectWithoutProperties(options, ["part", "value", "onChange", "locale", "format"]);

  var root = useSingleton(function () {
    return new Time(part);
  });
  var onChangeCallback = useRefCallback(onChange);
  var formatGetter = useRefGetter(function () {
    var showHour = extra.showHour,
        showMinute = extra.showMinute,
        showSecond = extra.showSecond;

    if (format) {
      !/H|h/g.test(format) && (extra.showHour = false);
      !/m/g.test(format) && (extra.showMinute = false);
      !/s/g.test(format) && (extra.showSecond = false);
      return format;
    }

    if (showHour != null || showMinute != null || showSecond != null) {
      var formatStr = [showHour || showHour == null ? 'HH' : '', showMinute || showMinute == null ? 'mm' : '', showSecond || showSecond == null ? 'ss' : ''].filter(function (item) {
        return !!item;
      }).join(':');
      return formatStr;
    }

    return locale.defaultFormat.time;
  });
  var date = parseDate(value, formatGetter()(), locale);
  root.updateOptions(extra);
  root.updateTime(date);
  useEffect(function () {
    var callback = function callback(value) {
      onChangeCallback(formatDate(value, formatGetter()(), locale));
    };

    root.addListener('value-change', callback);
    return function () {
      root.removeListener('value-change', callback);
    };
  }, []);
  return root;
}